module.exports = __webpack_public_path__ + "img/315.0d477c68.png";